
export default function hotspotMapInit (hotspotMap) {
  // NOTE currently assuming: max one per page
  //                          required: reference, hotspot
  //                          optional: detail

  const hotspotReference = document.querySelector('.hotspot-reference');
  const hotspotDetail = document.querySelector('.hotspot-detail');

  // hovering the reference text
  hotspotReference.querySelectorAll('a').forEach((reference) => {
    const hotspot = reference.getAttribute('id').replace('reference-', 'hotspot-');
    const detail = reference.getAttribute('id').replace('reference-', 'detail-');
    reference.addEventListener('mouseenter', (e) => {
      document.getElementById(hotspot).classList.add('highlight');
    });
    reference.addEventListener('mouseleave', (e) => {
      document.getElementById(hotspot).classList.remove('highlight');
    });
    reference.addEventListener('click', (e) => {
      if (hotspotDetail) {
        e.preventDefault();
        hotspotDetail.querySelector('.visible').classList.remove('visible');
        document.getElementById(detail).classList.add('visible');
      }
    });
  });


  // hovering the map number
  hotspotMap.querySelectorAll('a').forEach((hotspot) => {
    const reference = hotspot.getAttribute('id').replace('hotspot-', 'reference-');
    hotspot.addEventListener('mouseenter', (e) => {
      document.getElementById(reference).classList.add('highlight');
    });
    hotspot.addEventListener('mouseleave', (e) => {
      document.getElementById(reference).classList.remove('highlight');
    });
  });
}



// WEBPACK FOOTER //
// ./assets/j/src/hotspot.js